import React from 'react';
import { Button, ConfirmationModal } from 'bench-internal-theme';
import { openModal } from 'modal-core-components';
import { useMutation } from '@apollo/client';
import { useClient } from '../../../ClientContext';
import { Connection } from '../../types';
import { toastError, toastSuccess } from 'bench-internal-theme';
import { DELETE_CONNECTION, DELETE_RUTTER_CONNECTION } from '../../queries';
import refetchQueries from '../refetchQueries';
import { useV2Mutation } from '../../../../utils';

type DeleteButtonProps = {
  connection: Connection;
};
const DeleteButton = ({ connection }: DeleteButtonProps) => {
  const { id: clientId } = useClient();

  const [deleteConnection, { loading }] = useMutation(DELETE_CONNECTION, {
    awaitRefetchQueries: true,
    onCompleted: () => {
      toastSuccess('Connection', 'Connection was successfully deleted.');
    },
    onError: () => {
      toastError('Connection', 'There was a problem deleting this connection.');
    },
    refetchQueries: refetchQueries(clientId),
  });

  const [deleteRutterConnection, { loading: loadingPayPal }] = useV2Mutation(
    DELETE_RUTTER_CONNECTION,
    {
      onCompleted: () => {
        toastSuccess('Connection', 'Connection was successfully deleted.');
      },
      onError: () => {
        toastError('Connection', 'There was a problem deleting this connection.');
      },
    },
  );

  const handleDelete = () =>
    connection.source === 'PAYPAL' || connection.source === 'AMAZON'
      ? deleteRutterConnection({
          variables: {
            input: {
              id: connection.id,
            },
          },
        })
      : deleteConnection({
          variables: { connectionId: connection.id },
        });

  const onClick = () => {
    openModal(closeModal => (
      <ConfirmationModal
        closeModal={closeModal}
        description={`Deleting this ${
          connection.financialInstitutionName ?? connection.source
        } connection will stop importing transactions into ledgers and remove accounts mapped to ledgers. This action is not reversible.`}
        onConfirm={handleDelete}
        title="Are you sure?"
      />
    ));
  };

  return (
    <Button icon="close" disabled={loading || loadingPayPal} styleType="primary" onClick={onClick}>
      Delete
    </Button>
  );
};

export default DeleteButton;
